import React, { useCallback, useMemo } from 'react';
import clsx from 'clsx';
import { StatsCard } from 'common/components';
import { useStyles } from 'features/command-center/components/shared';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS, TABLES_KEYS } from 'features/command-center/constants';
import useDatatable, { getColumnPreferences, getColumnsToRender } from 'hooks/datatable';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import DataTable from 'UI/components/organisms/DataTable';

import { WIDGETS } from '../../productionBoard.constants';
import { formatProductionResponse, getAvailableDataColumns } from '../../productionBoard.utils';

import { ORDER_BY_OPTIONS, PRODUCTION_BY_WEEK_COLUMNS } from './productionByWeek.columns';
import { ProductionRecruitersByWeek } from './ProductionRecruiterByWeek';

const TABLE_KEY = TABLES_KEYS.productionBoardByWeek;
const initialPreferences = getColumnPreferences(
  TABLE_KEY,
  0,
  ORDER_BY_OPTIONS,
  PRODUCTION_BY_WEEK_COLUMNS
);

export const ProductionByWeek = ({ queryParams, onLoadWidgetData }) => {
  const classes = useStyles();
  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.productionBoardByWeek}?${queryParams}`;

  const handleFetchedData = useCallback(
    ({ data: { total } }) => {
      onLoadWidgetData({ [WIDGETS.mtdProduction]: total });
    },
    [onLoadWidgetData]
  );

  const { data, listState, columnPreferences, handleColumnSortChange } = useDatatable({
    key: TABLE_KEY,
    apiInstance: SECONDARY_API_CLIENT,
    columnsDefinitions: PRODUCTION_BY_WEEK_COLUMNS,
    endpoint,
    formatResponse: formatProductionResponse,
    initialPreferences,
    onFetchedData: handleFetchedData,
    orderByOptions: ORDER_BY_OPTIONS
  });

  const { isLoading, showWholeSkeleton } = listState;
  const { columns, direction, orderBy } = columnPreferences;
  const finalColumns = useMemo(
    () => getAvailableDataColumns({ columns: getColumnsToRender(columns), data }),
    [columns, data]
  );
  const isEmpty = Array.isArray(data) && data.length === 0;

  return (
    <StatsCard
      header={strings.commandCenter.productionBoard.byWeek}
      subheader={strings.commandCenter.productionBoard.notes.updates}
      paddingContent={0}
    >
      <DataTable
        className={clsx(classes.mediumWeightRow, {
          [classes.firstRow]: !isEmpty
        })}
        columns={finalColumns}
        components={{ TableToolbar: () => null }}
        data={data}
        elevation={0}
        expandableRows
        expandableRowsHeader={false}
        filter={false}
        isRowExpandable={() => true}
        loading={showWholeSkeleton}
        onColumnSortChange={handleColumnSortChange}
        refreshing={isLoading}
        rowsExpanded={[]}
        search={false}
        selectableRows="none"
        viewColumns={false}
        renderExpandableRow={rowData => {
          return (
            <ProductionRecruitersByWeek
              columns={finalColumns}
              selectedTeam={rowData[0]}
              queryParams={`${queryParams}&orderBy=${orderBy}&direction=${direction}`}
            />
          );
        }}
      />
    </StatsCard>
  );
};
